import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      primary: { primaryBlue7, primaryBlue, primaryBlue2 },
      gray: { grayEA },
    },
  } = styleConfig;
  return {
    headerBackground: {
      background: `linear-gradient(to bottom, ${primaryBlue7} 0%, ${primaryBlue} 53%, ${primaryBlue2} 100%)`,
    },
    logoStyle: { width: 144, height: 37, marginRight: 12, marginTop: 5 },
    langButtonWrapper: {
      maxHeight: window.innerHeight / 2,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      padding: '8px 0px',
      position: 'relative',
    },
    langButton: {
      fontSize: 12,
      textTransform: 'capitalize',
      display: 'flex',
      justifyContent: 'flex-start',
      lineHeight: 1.5,
      padding: '6px 12px',
      color: 'inherit',
      cursor: 'pointer',
      '&:focus': { boxShadow: `0 1px ${grayEA}` },
      '&:hover': {
        backgroundColor: grayEA,
        outline: `2px solid ${grayEA}`,
      },
    },
  };
};

export default styles;
